function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "128.215 100.025 274.294 96.218",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 128.215 138.707 L 335.522 138.707 L 335.522 157.792 L 128.215 157.792 L 128.215 138.707 Z",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 368.927 114.552 L 417.036 181.716 L 320.818 181.716 L 368.927 114.552 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0
    },
    transform: "matrix(0, 1, -1, 0, 517.061035, -220.792999)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLong);
export default __webpack_public_path__ + "static/media/arrow-long.23a157e27dfe21e134c61b4a9cf578b3.svg";
export { ForwardRef as ReactComponent };